import { useTranslation } from 'react-i18next';

import { Modal } from '@treams/treams-ui';

import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';

export default function FeedbackRequestModalLoading(props: { returnURL: string }) {
	const { t } = useTranslation();

	return (
		<Modal>
			<Modal.Header title={t('common.feedback.create')} />
			<Modal.Contents>
				<Spinner isLoading size="18px" />
			</Modal.Contents>
		</Modal>
	);
}
